import { computed } from 'vue'
import { formatAmount } from 'foundation/js/utils/numberUtils'

export default {
    name: 'PersonalFundraisingListItem',
    props: {
        name: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            default: 0
        },
        url: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const formattedAmount = computed(
            () => `${formatAmount(props.amount, 0)} kr.`
        )
        const isLink = computed(() => !!props.url)

        return {
            formattedAmount,
            isLink
        }
    }
}
